import api from "./index";
import vUtil from "@utils/vUtil.min";
import store from "@/store";
export const recordEven = (clickname, questionname) => {
  const pushData = {
    source: vUtil.Location.search("source") || "直接访问",
    clickname,
    videoname: store.getState().videoData.path
  };
  questionname && (pushData.questionname = questionname);
  api("RECORDEVEN", pushData);
};
